import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { EventTypeCategory } from '../../../../../models/event-type';
import { AccountService } from '../../../../../services/account/account.service';
import { EventTypeService } from '../../../../../services/event-type/event-type.service';
import { searchList } from '../../../../../utils';


@Component({
  selector: 'app-select-event-category-modal',
  templateUrl: './select-event-category-modal.component.html',
  styleUrls: ['./select-event-category-modal.component.css']
})
export class SelectEventCategoryModalComponent implements OnInit {

  @Input() excludeIds: number[];
  @Input() submitCallback: (eventCategory: EventTypeCategory) => undefined;

  public loadingCategories = false;
  public searchInput = '';

  public categories: EventTypeCategory[];
  public selectedCategory: EventTypeCategory = null;

  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private eventTypeService: EventTypeService,
    private accountService: AccountService
  ) {}

  ngOnInit() {
    this.loadCategories();
  }

  public filteredCategories(): EventTypeCategory[] {
    return searchList<EventTypeCategory>(
      this.searchInput,
      this.categories.map(cat => {
        return {
          value: cat,
          searchableText: cat.name
        };
      })
    );
  }

  public handleSearchInputChange() {
    this.selectedCategory = null;
  }

  public selectCategory(cat: EventTypeCategory) {
    this.selectedCategory = cat;
    this.searchInput = cat.name;
  }

  public validInputSelected() {
    return this.selectedCategory !== null;
  }

  public handleSave() {
    this.submitCallback(this.selectedCategory);
    this.activeModal.close();
  }

  private loadCategories() {
    this.loadingCategories = true;

    this.eventTypeService
      .getEventTypeCategories(1, 3000)
      .then(response => {
        this.categories = response.results.filter(cat => !this.excludeIds.includes(cat.id));
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingCategories = false; });
  }
}
